import React, { Fragment, useEffect } from "react";
import Form from "./Form";
import Logo from "../images/logo.png"
import AlternateEmailRoundedIcon from "@mui/icons-material/AlternateEmailRounded";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import useIntersect from "./util/useIntersect";
import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import Faq from "./Faq";

function Contact() {
  const [ref, entry] = useIntersect({
    threshold: 0,
    rootMargin: "0% 0% 0% 0%",
  });
  useEffect(() => {
    if (entry.isIntersecting) {
      if (entry.isIntersecting) {
        document.querySelectorAll(".nav-link").forEach((i) => {
          i.classList.remove("active");
        });
        document.getElementById("nav-contact").classList.add("active");
        // setPosition1("services");
        // document.getElementById("service-title").classList.add("show-line");
      }
    }
    // eslint-disable-next-line
  }, [entry.isIntersecting]);
  const position = { lat: -1.3338779097216062, lng: 36.91772580883023 };
  const mapUrl = `https://maps.google.com/maps?q=${position.lat},${position.lng}&z=15&output=embed`;
  return (
    <Fragment>
      <div
        className="grid lg:grid-cols-2 grid-cols-1 gap-10 px-[2rem] mt-0 pt-32  lg:px-[4rem]"
        id="contact"
        ref={ref}
      >
        <Form />
        <div className="rounded-xl min-h-96 overflow-hidden bg-black">
          <iframe
            title="Google Map"
            src={mapUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* <div className="faq-container">
          <h4 className="section-title black">Frequently Asked Questions</h4>
          <div className="faq">
            <div className="faq-s">
              <span className="q">
                What types of cargo does Saharawinds handle?
              </span>
              <span className="a">
                We specialize in handling a wide range of cargo, including
                perishables like flowers, fruits, vegetables, seafood, and
                foodstuffs. Our team has the expertise and facilities to ensure
                your cargo remains in optimal condition from origin to
                destination.
              </span>
            </div>
            <div className="faq-s">
              <span className="q">
                How do you handle customs and trade compliance for international
                shipments?
              </span>
              <span className="a">
                Our experienced team manages all customs documentation and
                provides guidance on trade compliance, including certifications
                like phytosanitary and CTPAT, as well as adherence to trade
                protocols like AGOA, COMESA, and EU trade agreements.
              </span>
            </div>
            <div className="faq-s">
              <span className="q">
                How can I get a quote or book a shipment with Saharawinds?
              </span>
              <span className="a">
                Getting a quote or booking a shipment is easy! Simply reach out
                through our contact form, email, or call us directly. Our team
                will provide a customized quote and guide you through the
                booking process based on your specific needs.
              </span>
            </div>
            <div className="faq-s">
              <span className="q">What geographic regions do you cover?</span>
              <span className="a">
                We operate both locally within East Africa and internationally.
                Thanks to our network of global partners, we provide
                door-to-door delivery options worldwide and maintain space
                protection agreements with major airlines and shipping lines.
              </span>
            </div>
            <div className="faq-s">
              <span className="q">
                Can you manage both air and sea shipments?
              </span>
              <span className="a">
                Yes, Saharawinds offers comprehensive air and sea logistics
                solutions. We handle everything from documentation and cargo
                consolidation to customs clearance, ensuring a smooth and
                reliable experience for imports and exports.
              </span>
            </div>
            <div className="faq-s">
              <span className="q">
                How does Saharawinds ensure the quality of perishable goods
                during transit?
              </span>
              <span className="a">
                We use advanced cold chain solutions, including
                temperature-controlled packaging, warehousing, and transport, to
                maintain the freshness and safety of perishable items.
              </span>
            </div>
          </div>
        </div> */}
      </div>
      <Faq />
      <div className="details text-[color:var(--brand-primary)] lg:px-[4rem] px-[2rem] m-0 pt-0 lg:py-[3rem]">
        <div><img src={Logo} alt="Saharawinds" className="lg:h-14 h-12 lg:pb-2 pb-0"/></div>
        <div className="aad">
          <div className="flex flex-col gap-2">
            <div className="wrap">
              <LocationOnRoundedIcon />
              <span>
                <b>Saharawinds Ltd</b> | JKIA Cargo Center
                <br />
                P.o. Box 52203 - 00100 Nairobi Kenya |{" "}
                <a href="tel:+254704936937">T: +254 704 936 937</a>
                <br />
                <a href="mailto:commercial@saharawinds.ke">e: commercial@saharawinds.ke</a> |{" "}
                <a href="https://www.saharawinds.ke" target="_blank" rel="noreferrer">
                  w: www.saharawinds.ke
                </a>
                <br />
                <span className="opacity-80">Logistics Excellence</span>
              </span>
            </div>
          </div>
        </div>
        <div className="social">
          <a href="https://wa.me/254704936937" target="_blank" rel="noreferrer">
            <WhatsAppIcon fontSize="" className="social-icon text-[color:var(--brand-primary)]" />
          </a>
          <a
            href="https://www.linkedin.com/company/saharawinds/?viewAsMember=true"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon fontSize="" className="social-icon text-[color:var(--brand-primary)]" />
          </a>
        </div>
      </div>
      <br/>
      <p className="text-center mb-4">Copyright © 2025 <a className="font-bold cursor-pointer" href="https://iano.marketing" target="_blank" rel="noreferrer">iano</a>. All rights reserved.</p>
    </Fragment>
  );
}

export default Contact;
